import { render, staticRenderFns } from "./TaskFunction.vue?vue&type=template&id=094cacae&"
import script from "./TaskFunction.vue?vue&type=script&lang=js&"
export * from "./TaskFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports